import axios from 'axios';

// Same-origin '' is correct for Docker (nginx proxies /api to the backend).
// CRA dev uses package.json "proxy" so /api from localhost:3000 reaches the API.
// Override only when needed: REACT_APP_API_URL=http://localhost:5000
export const API_BASE_URL =
  typeof process.env.REACT_APP_API_URL === 'string' && process.env.REACT_APP_API_URL.length > 0
    ? process.env.REACT_APP_API_URL
    : '';

const client = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  // Match nginx proxy_read_timeout (3600s). Default is browser-dependent (often 60s)
  // which causes 499 client-closed-request errors on long-running full data refreshes.
  timeout: 3600000,  // 1 hour in milliseconds
});

// 401 handler — let the AuthContext take care of state; redirect handled by the router.
let onUnauthorized = null;
export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && onUnauthorized) {
      onUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default client;
